"use client";
import { Fragment } from "react";
//#region packages/@mantine/core/src/core/utils/is-element/is-element.ts
function isElement(value) {
	if (Array.isArray(value) || value === null) return false;
	if (typeof value === "object") {
		if (value.type === Fragment) return false;
		return true;
	}
	return false;
}
//#endregion
export { isElement };

//# sourceMappingURL=is-element.mjs.map